<template>
    <div class="container-fluid" v-if="!this.$store.state.preloader">
        <div class="row">
            <div class="col-sm-12 mb-5">
                <h2 class="text-center">
                    <!-- <img src="~img/logo_black.png" alt="Logo"> -->
                </h2>
            </div>
        </div>

        <div class="text-center">
            <h1>{{ $t("general.change_email.title") }}</h1>
        </div>
        <div class="row" v-if="this.wait">
            <div class="mt-5 text-center wait-content">
                <div class="row content">
                    <div class="col-sm-12 mt-3">
                        <div class="form-group text-center">
                            <i class="fa fa-circle-o-notch fa-spin fa-5x"></i>
                            <br/>
                            <br/>
                            <b>{{ $t("general.change_email.wait") }}</b>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" v-if="!this.wait">
            <div class="mt-5 text-center wait-content" :class="{ 'text-danger': !this.ok }">
                <div class="row content">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <i class="fa fa-check fa-5x" v-if="this.ok"></i>
                            <i class="fa fa-ban fa-5x" v-if="!this.ok"></i>
                            <br/>
                            <br/>
                            <b v-if="this.ok">{{ $t("general.change_email.ok") }}</b>
                            <b v-if="!this.ok">{{ $t("general.change_email.nok") }}</b>
                        </div>
                    </div>
                    <div class="footer" v-if="this.ok">
                        <div class="form-group text-center">
                            <router-link tag="a" to="/login" class="btn btn-success">{{ $t("general.login.title") }}</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue';
    import http from '@/libs/http';
    import miniToastr from 'mini-toastr';

    export default {
        components: {},
        name: 'confirm_email_page',

        data() {
            return {
                wait: true,
                ok: true
            }
        },
        created: function() {
        },
        computed: {
            user() {
                return this.$store.state.user;
            },
        },
        watch: {
            user: {
                immediate: true,

                handler(newVal, oldVal) {
                }
            },
        },
        created: function() {
            if (this.$route.params.id && this.$route.params.token) {
                let data = http.route('change-email').post({
                    id: this.$route.params.id,
                    token: this.$route.params.token,
                    }, true);
                    data.then(response => {
                        this.wait = false;
                        if (response.isError) {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage));
                            this.ok = false;
                        }
                    });
            } else {
                this.wait = false;
                this.ok = false;
                this.errorMsg(Vue.i18n.translate('general.change_email.nok'));
            }
        },
        mounted: function () {
        },
        updated: function(){
        },
        methods: {
            successMsg(msg) {
                miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
            },
            errorMsg(msg) {
                miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
            },
        }
    }
</script>

<style scoped>
    h1 {
        margin: auto;
        text-align: center;
    }
    .container-fluid {
        margin-top: 10%;
    }
    .btn.btn-success {
        font-size: 20px;
        border-radius: 5px;
    }
    .wait-content {
        margin: 0 auto;
        width: 80%;
        display:inline-block;
        color:green;
    }
    .wait-content b {
        color:blue;
    }

    .mt-5, .my-5 {
        margin-top: 1rem !important;
    }
    .footer {
        width: 100%;
        margin: 0px 20px 10px 20px;
    }
    .btn {
        padding: 5px 12px;
        font-size: 14px !important;
    }
    .img_backgrond{
        background-size:cover;
        background-repeat:no-repeat;
        width: 100%;
        padding: 75px 15px;
    }
    label{
        font-size: 14px !important;
    }
    ::-webkit-input-placeholder {
        font-size:14px;
    }

    @media screen and (min-width: 1200px) {
        .login-content {
            width: 400px;
            max-width: 95% !important;
            margin: auto;
            overflow: hidden;
        }
    }

    @media screen and (max-width: 1200px) {
        .login-content {
            width: 400px;
            max-width: 95% !important;
            margin: 0 auto;
            overflow: hidden;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/authentication/confirm_email_page.vue